/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_All_Plans_IncludeInputs */

const en_plan_all_plans_include = /** @type {(inputs: Plan_All_Plans_IncludeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All plans include:`)
};

const es_plan_all_plans_include = /** @type {(inputs: Plan_All_Plans_IncludeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los planes incluyen:`)
};

/**
* | output |
* | --- |
* | "All plans include:" |
*
* @param {Plan_All_Plans_IncludeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_all_plans_include = /** @type {((inputs?: Plan_All_Plans_IncludeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_All_Plans_IncludeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_all_plans_include(inputs)
	return en_plan_all_plans_include(inputs)
});